import * as yup from 'yup';
import {
  DEFAULT_MAX_LENGTH,
  EMAIL,
} from '../../../utils/validation/validationRules';
import { validationErrors } from '../../../utils/validation/validationErrors';

export const contactUsValidationSchema = yup.object().shape({
  name: DEFAULT_MAX_LENGTH.required(validationErrors.REQUIRED_FIELD),
  email: EMAIL.required(validationErrors.REQUIRED_FIELD),
  question: yup
    .string()
    .max(510, 'Must be less than 510 characters')
    .required(validationErrors.REQUIRED_FIELD),
});
